var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.53029 7.46975C8.23739 7.17686 7.76252 7.17686 7.46963 7.46975C7.17673 7.76265 7.17673 8.23752 7.46963 8.53041L10.9393 12.0001L7.46963 15.4698C7.17673 15.7626 7.17673 16.2375 7.46963 16.5304C7.76252 16.8233 8.23739 16.8233 8.53029 16.5304L12 13.0607L15.4696 16.5304C15.7625 16.8233 16.2374 16.8233 16.5303 16.5304C16.8232 16.2375 16.8232 15.7626 16.5303 15.4698L13.0606 12.0001L16.5303 8.53041C16.8232 8.23752 16.8232 7.76265 16.5303 7.46975C16.2374 7.17686 15.7625 7.17686 15.4696 7.46975L12 10.9394L8.53029 7.46975Z",
    fill: "#FF3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedNo);
export default __webpack_public_path__ + "static/media/redNo.5cfabae2106fd34105711d002c0a0e95.svg";
export { ForwardRef as ReactComponent };